/**
 * filter/CourseRows
 *
 * Responsible for behavior of "browse results" course row elements
 * Should be used in combination with the course-list partial
 */
define('filter/CourseRows',[
    'jquery',
    'ch_ga',
    'semantic',
], function ($, ga) {
    // handler for when a user has selected a schedule from the table and they click "attend"
    const _handlerSubmitScheduleForm = function (e) {
        e.preventDefault();
        $(this)
            .parents('.js-course-row')
            .find('form')
            .trigger('submit');
    };

    /**
     * initializeCourseRows
     *
     * Set up all behavior for each course row in the filter results list
     *
     * - Click tracking
     * - GA Events
     * - Loading "Other schedules" via ajax
     * - Making sure the selected schedule is sent when user clicks "attend"
     *
     * // @todo convert event handlers to be delegated from the rootElement
     *
     */
    function initializeCourseRows($rootElement) {
        const $courseRows = $('.js-course-row:not(.js-initialized)', $rootElement);
        const $courseSchedules = $('.js-course-schedules', $courseRows);

        // disable some links
        $('.js-disabled-link', $courseRows).on('click', function (e) {
            e.preventDefault();
        });

        // track clicks within course schedules, which are dynamically loaded
        $courseSchedules.on('click', '.go-to-course', function (e) {
            ga(
                'send',
                'event',
                'Filter Click Positions',
                'Course clicked',
                $(this)
                    .closest('.js-course-row')
                    .data('click-position')
            );
        });

        // CH-6547: Track popular class clicks
        $courseRows.filter('.is-popular').on('click', function (e) {
            ga(
                'send',
                'event',
                'Filter Click Positions',
                'Popular course clicked',
                $(this).data('click-position')
            );
        });

        // ability to close the loaded "other times", which are dynamically loaded
        $courseSchedules.on('click', '.close', function (e) {
            const $courseRow = $(this).parents('.js-course-row');

            e.preventDefault();

            $courseRow.find('.js-schedules-wrapper').slideUp();
            $courseRow.find('.js-load-schedules').slideDown();

            $('.attend', $courseRow).off('click', _handlerSubmitScheduleForm);

            ga('send', 'event', 'Filter Page', 'Other Dates', 'Closed');

            window.CH.scrollToElement($courseRow);
        });

        // entire schedule row click should set the checkbox value to "checked", which are dynamically loaded
        $courseSchedules.on('click', 'tr:not(.last)', function (e) {
            const $scheduleRow = $(this);
            const $courseRow = $scheduleRow.parents('.js-course-row');

            $courseRow
                .find('tr')
                .removeClass('checked');

            $scheduleRow
                .addClass('checked')
                .find('input')
                .prop('checked', true)
                .trigger('change');
        });

        // load and/or display "other" schedules
        $('.js-load-schedules', $courseRows).on('click', function (e) {
            const $trigger = $(this);
            const $courseRow = $trigger.parents('.js-course-row');
            const $timesSection = $courseRow.find('.js-course-schedules');
            const $loader = $('.js-loader', $timesSection);
            const $scheduleWrapper = $('.js-schedules-wrapper', $timesSection);
            const defaultSectionId = $trigger.data('default-section-id');

            e.preventDefault();

            $loader.addClass('active');

            // avoid re-loading data via ajax
            if (!$timesSection.hasClass('loaded')) {
                $.ajax({
                    type: 'GET',
                    url: '/course/course/get-course-active-sections',
                    dataType: 'html',
                    data: {
                        course_id: $trigger.data('course-id'),
                    },
                    success: function (html) {
                        $scheduleWrapper
                            .html(html)
                            .slideDown();

                        if (defaultSectionId) {
                            $scheduleWrapper
                                .find('input[value=' + defaultSectionId + ']')
                                .prop('checked', true);
                        }

                        $timesSection.addClass('loaded');
                        $trigger.slideUp();
                    },
                });
            } else {
                $scheduleWrapper.slideDown();
                $trigger.slideUp();
            }

            // "attend" button should trigger form submission when a schedule list is displayed
            $('.js-attend', $courseRow).on('click', _handlerSubmitScheduleForm);

            ga('send', 'event', 'Filter Page', 'Other Dates', 'Opened');
        });

        // lazy load re-trigger
        const $images = $('.js-lazy-load', $rootElement);

        if ($images.length > 0) {
            $images.removeClass('js-lazy-load');
            $images.unveil(400, function () {
                $(this).on('load', function () {
                    $(this)
                    // mark loaded
                        .addClass('lazy-loaded')
                        // disable the spinner
                        .siblings('.active.dimmer')
                        .removeClass('active');
                });
            });
        }

        $('.course-review-link', $courseRows).on('click', function () {
            ga(
                'send',
                'event',
                'reviews',
                'Clicked browse page review stars',
                $(this).attr('href'),
                { nonInteraction: false }
            );
        });

        // all done
        $courseRows.addClass('js-initialized');
    }

    function initializeFilterInteractions($rootElement) {
        const $courseRows = $('.js-course-row', $rootElement);
        // set up click handlers for any links in the page that want to dynamically set a filter value
        // such as the "filter by this level!" and "filter by this location!" links in each course row
        const $levelFilter = $('.js-skill-level-filter');
        const $neighborhoodFilter = $('#js-neighborhoods-filters');
        const $remoteLearningFilter = $('.js-remote-learning');

        if ($levelFilter.length) {
            $('.js-set-course-level', $courseRows).on('click', function (e) {
                e.preventDefault();
                $levelFilter
                    .find('.ui.checkbox')
                    .checkbox('uncheck')
                    .find('input[value="' + $(this).data('level') + '"]')
                    .parents('.ui.checkbox')
                    .checkbox('check');
                CH.scrollTo(0);
            });
        }

        if ($neighborhoodFilter.length) {
            $('.js-set-location', $courseRows).on('click', function (e) {
                e.preventDefault();
                $neighborhoodFilter
                    .find('.ui.checkbox')
                    .checkbox('uncheck')
                    .find('input[value="' + $(this).data('uri') + '"]')
                    .parents('.ui.checkbox')
                    .checkbox('check');
                CH.scrollTo(0);
            });
        }

        if ($remoteLearningFilter.length) {
            $('.js-set-remote-learning', $courseRows).on('click', function (e) {
                e.preventDefault();
                $remoteLearningFilter
                    .find('.ui.checkbox')
                    .checkbox('check');
                CH.scrollTo(0);
            });
        }
    }

    /**
     * addSnippets
     *
     * Fetch rich snippet events via ajax and add to the DOM so Google can see them
     */
    function loadSnippets(courseIds, providerIds) {
        const data = {
            providerIds: CH.providerIds,
        };

        // If the event snippets were already loaded on page load, don't load via ajax
        if (!$('#course-event-snippets').length) {
            data.courseIds = CH.courseIds;
        }

        // If we have nothing to load, don't request
        if (
            (!data.providerIds || data.providerIds.length <= 0)
            && (!data.courseIds || data.courseIds.length <= 0)
        ) {
            return;
        }

        // Get rich snippets for the page
        $.ajax({
            type: 'GET',
            url: '/course/filter/get-rich-snippets',
            data: data,
            dataType: 'html',
            success: function (html) {
                $('head').append(html);
            },
        });
    }

    return {
        initRows: function ($rootElement, options) {
            const mergedOptions = Object.assign({
                isFiltersEnabled: true,
            }, options);

            // set up row behavior
            initializeCourseRows($rootElement);

            // support for rows to interact with filters
            if (mergedOptions.isFiltersEnabled) {
                initializeFilterInteractions($rootElement);
            }
        },
        loadSnippets: loadSnippets,
    };
});

